import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BookComponent } from './book/book.component';
import { CardModule } from '@spartacus/storefront';
import { SharedModule } from '@shared/shared.module';

@NgModule({
  declarations: [BookComponent],
  imports: [CommonModule, CardModule, SharedModule],
})
export class CustomAddressBookModule {}
